import { lazy } from "react";

const ViewCertificates = lazy(() => import("./ViewCertificates"));
const MyRequests = lazy(() => import("./MyRequests"));
const RequestCertificate = lazy(() => import("./RequestCertificate"));
const PricingTable = lazy(() => import("./PricingTable"));
const SearchResults = lazy(() => import("./SearchResults"));
const UserProfile = lazy(() => import("./UserProfile"));
const BlankPage = lazy(() => import("./BlankPage"));
const PolicyDetails = lazy(() => import("./PolicyDetails"));
const ApplicationDetails = lazy(() => import("./ApplicationDetails"));
const ApplicationForm = lazy(() => import("./ApplicationForm"));
const ApplicationList = lazy(() => import("./ApplicationList"));
const PolicyForm = lazy(() => import("./PolicyForm"));
const PolicyList = lazy(() => import("./PolicyList"));
const PolicyListDetail = lazy(() => import("./PolicyListDetail"));
const AdminPage = lazy(() => import("./AdminPage"));
const ProfilePage = lazy(() => import("./ProfilePage"));
const EntityList = lazy(() => import("./EntityList"));
const PolicyTypesList = lazy(() => import("./PolicyTypes"));
const ClauseLibrary = lazy(() => import("./ClauseLibrary"));
const InsurerLibrary = lazy(() => import("./InsurerLibrary"));
const PolicyRenewals = lazy(() => import("./PolicyRenewals"));
const BrokerManagement = lazy(() => import("./BrokerManagement"));
const Notification = lazy(() => import("./Notification"));
const Acord = lazy(() => import("./Acord"));
const CustomerForm = lazy(() => import("./CustomerForm"));
const CustomerList = lazy(() => import("./CustomerList"));
const CustomerDetails = lazy(() => import("./CustomerDetails"));
const LeadForm = lazy(() => import("./LeadForm"));
const LeadManagement = lazy(() => import("./LeadManagement"));
const LeadDetails = lazy(() => import("./LeadDetails"));
const ClaimForm = lazy(() => import("./ClaimForm"));
const ClaimList = lazy(() => import("./ClaimList"));
const ClaimDetails = lazy(() => import("./ClaimDetails"));
const ClaimsDashboard = lazy(() => import("./ClaimsDashboard"));
const CertificateInformation = lazy(() => import("./CertificateInformation"));
const Reports = lazy(() => import("./Reports"));
const OnboardingWorkspace = lazy(() => import("./OnboardingWorkspace"));

const FAQ = lazy(() => import("./FAQ"));
const AdminDashboard = lazy(() =>
  import("../dashboard/dashboard2/AdminDashboard")
);

const pagesRoutes = [
  {
    path: "/onboarding/:tab?",
    element: <OnboardingWorkspace />,
  },
  {
    path: "/pages/pricing-table",
    element: <PricingTable />,
  },
  {
    path: "/pages/search-results",
    element: <SearchResults />,
  },
  {
    path: "/pages/user-profile",
    element: <UserProfile />,
  },
  {
    path: "/pages/faq",
    element: <FAQ />,
  },
  {
    path: "/pages/blank-page",
    element: <BlankPage />,
  },
  {
    path: "/pages/policy-details/*",
    element: <PolicyDetails />,
  },
  {
    path: "/pages/application-details/:number",
    element: <ApplicationDetails />,
  },
  {
    path: "/pages/application-form",
    element: <ApplicationForm />,
  },
  {
    path: "/pages/application-list",
    element: <ApplicationList />,
  },
  {
    path: "/pages/policy-form/:policyId",
    element: <PolicyForm />,
  },
  {
    path: "/pages/policy-list",
    element: <PolicyList />,
  },
  {
    path: "/pages/policy-list-details",
    element: <PolicyListDetail />,
  },
  {
    path: "/pages/policy-types",
    element: <PolicyTypesList />,
  },
  {
    path: "/pages/clause-library",
    element: <ClauseLibrary />,
  },
  {
    path: "/pages/insurers",
    element: <InsurerLibrary />,
  },
  {
    path: "/pages/policy-renewals",
    element: <PolicyRenewals />,
  },
  {
    path: "/pages/brokers",
    element: <BrokerManagement />,
  },
  {
    path: "/pages/admin-page",
    element: <AdminPage />,
  },
  {
    path: "/pages/profile-page",
    element: <ProfilePage />,
  },
  {
    path: "/pages/entity-list",
    element: <EntityList />,
  },
  {
    path: "/pages/notification",
    element: <Notification />,
  },
  {
    path: "/pages/reports",
    element: <Reports />,
  },
  {
    path: "/acord",
    element: <Acord />,
  },
  {
    path: "/customerform/:businessId?",
    element: <CustomerForm />,
  },
  {
    path: "/customer-list",
    element: <CustomerList />,
  },
  {
    path: "/customer-roster",
    element: <CustomerList />,
  },
  {
    path: "/customerdetails/:businessId",
    element: <CustomerDetails />,
  },
  {
    path: "/leadform/:leadId",
    element: <LeadForm />,
  },
  {
    path: "/leadmanagement",
    element: <LeadManagement />,
  },
  {
    path: "/leaddetails/:leadId?",
    element: <LeadDetails />,
  },
  {
    path: "/claimform",
    element: <ClaimForm />,
  },
  {
    path: "/claimlist/:claimType",
    element: <ClaimList />,
  },
  {
    path: "/company-claims",
    element: <ClaimList />,
  },
  {
    path: "/claims-dashboard",
    element: <ClaimsDashboard />,
  },
  {
    path: "/claimdetails/:number",
    element: <ClaimDetails />,
  },
  {
    path: "/admindashboard",
    element: <AdminDashboard />,
  },
  {
    path: "/request-certificate",
    element: <RequestCertificate />,
  },
  {
    path: "/my-requests",
    element: <MyRequests />,
  },
  {
    path: "/certificate-information",
    element: <CertificateInformation />,
  },
  {
    path: "/view-certificates",
    element: <ViewCertificates />,
  },
];

export default pagesRoutes;
